import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StudentVerificationRoutingModule } from './student-verification-routing.module';
import { StudentVerificationLinkComponent } from './student-verification-link/student-verification-link.component';
import { StudentVerificationLandingComponent } from './student-verification-landing/student-verification-landing.component';
import { StudentVerificationComponent } from './student-verification/student-verification.component';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DialogMessageComponent } from './dialog-message/dialog-message.component';
import { StudentVerificationHeaderComponent } from './student-verification-header/student-verification-header.component';


@NgModule({
  declarations: [
    StudentVerificationLinkComponent,
    StudentVerificationLandingComponent,
    StudentVerificationComponent,
    DialogMessageComponent,
    StudentVerificationHeaderComponent
  ],
  imports: [
    CommonModule,
    StudentVerificationRoutingModule,
    AcademicFormModule,
    ReactiveFormsModule,
    FormsModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
  ]
})
export class StudentVerificationModule { }
